import { useDataContext } from "./DataProvider";
import { CouponBackgroundIcon } from "./icons/CouponBackgroundIcon";

export const ShortCoupon = () => {
	const { companyInfo } = useDataContext();
	const { shortCouponOffer, shortCouponDescription } = companyInfo;
	if (!shortCouponOffer) return null;

	return (
		<div className="tw:relative tw:w-full tw:rounded-b-2xl tw:bg-white tw:p-4 tw:md:rounded-t-lg tw:md:rounded-b-lg">
			<div className="tw:space-y-2">
				<p className="tw:text-xs tw:leading-3 tw:font-semibold tw:uppercase">
					Best Relocation Users Get
				</p>
				<p className="tw:text-[32px] tw:leading-8 tw:font-extrabold tw:tracking-[-0.64px] tw:uppercase">
					{shortCouponOffer}
				</p>
				<p className="tw:text-sm tw:leading-5 tw:font-medium">
					{shortCouponDescription}
				</p>
			</div>
			<CouponBackgroundIcon className="tw:absolute tw:-top-1 tw:right-0 tw:h-20 tw:w-20 tw:text-[#B6D8D8] tw:md:top-0 tw:md:h-15 tw:md:w-15" />
		</div>
	);
};
